import { SvgIcon, SvgIconProps } from '@material-ui/core';

const SendOutlineIcon: React.FC<Omit<SvgIconProps, 'children'>> = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 32 32" fill="none">
      <path
        d="M26.4 17.233L5.86667 25.8996C5.42222 26.0774 5 26.0385 4.6 25.783C4.2 25.5274 4 25.1552 4 24.6663V7.33297C4 6.84408 4.2 6.47186 4.6 6.2163C5 5.96075 5.42222 5.92186 5.86667 6.09964L26.4 14.7663C26.9556 15.0107 27.2333 15.4219 27.2333 15.9996C27.2333 16.5774 26.9556 16.9885 26.4 17.233ZM6.66667 22.6663L22.4667 15.9996L6.66667 9.33297V13.9996L14.6667 15.9996L6.66667 17.9996V22.6663Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default SendOutlineIcon;
